import React, { Component } from 'react';
import { gridView, listView, close, downCarrot, search, closeX } from '../library/Svgs';
import Autocomplete from 'react-autocomplete';

class CustomSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    const isVisible = elem =>
      !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    const _this = this;
    window.addEventListener('mouseup', (e) => {
      const container = document.querySelector('.custom-select');
      if (!!container && !container.contains(e.target)) {
        // or use: event.target.closest(selector) === null
        _this.setState({ open: false });
      }
    });
  }

  componentDidMount() {
    // console.log("There's a custom select around here...");
  }

  render() {
    const { options, value, change } = this.props;
    const { open } = this.state;
    return (
      <div className={`custom-select${open ? ' open' : ''}`}>
        <span
          className="icon"
          dangerouslySetInnerHTML={{ __html: downCarrot() }}
          onClick={() => {
            const { open } = this.state;
            this.setState({ open: !open });
          }}
        />
        <input
          className="selected"
          onClick={() => {
            const { open } = this.state;
            this.setState({ open: !open });
          }}
          readOnly="readonly"
          value={options.filter(x => x.value === value)[0].label}
        />
        <ul className="select-menu">
          {options.map(o => (
            <li className="select-option" key={`option-${o.label}`}>
              <button
                onClick={(e) => {
                  this.setState({ open: false });
                  change(o.value);
                }}
              >
                {o.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

const PerformanceReportsFilter = (props) => {
  const {
    view,
    setView,
    currentSearchTerm,
    setCurrentSearchTerm,
    autoCompleteValues,
    years,
    year,
    setYear,
  } = props;

  const niceYears = years.map((y, i) => ({ value: y, label: y }));
  niceYears.unshift({ value: 'year', label: 'All Years' });

  return (
    <div className="pipeline-filter performance-reports-filter">
      <div className="container">
        <div className="upper">
          <CustomSelect options={niceYears} value={year} change={setYear} />
          <Autocomplete
            getItemValue={item => item.label}
            items={autoCompleteValues}
            renderItem={(item, isHighlighted) => (
              <div
                className={isHighlighted ? 'highlighted' : ''}
                key={`autocomplete-item-${item.label}`}
              >
                {item.label}
              </div>
            )}
            value={currentSearchTerm}
            onChange={(e) => {
              setCurrentSearchTerm(e.target.value);
            }}
            onSelect={(val) => {
              setCurrentSearchTerm(val);
            }}
            inputProps={{ placeholder: 'Keyword Search' }}
            wrapperProps={{ className: 'autocomplete-wrapper' }}
            renderInput={props => <input className="autocomplete-input" {...props} />}
            renderMenu={(items, value) => <div className="autocomplete-menu" children={items} />}
          />
          <button
            className="reset-button"
            onClick={(e) => {
              setCurrentSearchTerm('');
              setYear('year');
            }}
          >
            <span dangerouslySetInnerHTML={{ __html: closeX }} />
          </button>
        </div>
        
      </div>
    </div>
  );
};

export default PerformanceReportsFilter;
